// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface String {
    prefix(pre: string): string;
    toUpperFirstCharacter(): string;
    toLowerFirstWord(): string;
    replaceWithParams(params: Record<string, string | number | boolean>): string;
}

String.prototype.prefix = function (pre: string) {
    return pre + this;
};

String.prototype.toUpperFirstCharacter = function () {
    return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
};

String.prototype.toLowerFirstWord = function () {
    const [first, ...others] = this.split(' ');
    return [first.toLowerCase(), ...others].join(' ');
};

String.prototype.replaceWithParams = function (params: Record<string, string | number | boolean>) {
    if (!params) {
        return this.toString();
    }
    // {a}
    const templateMatcher = /{\s?([^{}\s]*)\s?}/g;

    const getValue = (object: any, key: string) => {
        return object[key];
    };

    return this.replace(templateMatcher, (substring: string, b: string) => {
        const r = getValue(params, b);
        return r ?? substring;
    });
};
